define('SuiteDynamics.CriteoCustomDataLayerFields.EventProcessor',
    [
        'Tracker',
        'underscore'
    ],
    function(
        Tracker,
        _
    )
{
    'use strict';

    var EventProcessor = {
        container: null,
        eventHandlers: {},

        initialize: function(container) {
            this.container = container;
        },

        registerEventHandler: function(eventName, handler) {
            var self = this;

            if (!this.eventHandlers[eventName]) {
                this.eventHandlers[eventName] = [];
                Tracker.on(eventName, function(eventData) {
                    self.handleEvent(eventName, eventData);
                });
            }
            this.eventHandlers[eventName].push(handler);
        },

        handleEvent: function(eventName, eventData) {
            var handlers = this.eventHandlers[eventName];
            _.each(handlers, function(handler) {
                handler(eventData, this.container);
            }, this);
        }
    };

    return {
        mountToApp: function(container) {
            EventProcessor.initialize(container);
        },
        registerEventHandler: function(eventName, handler) {
            EventProcessor.registerEventHandler(eventName, handler);
        }
    };
});
